export type CaptureItemType = 'folder' | 'file';

// Video interface - matches the one in videosService.ts
// Defined here to avoid module resolution issues during build
export interface Video {
  id: string;
  org_id: string;
  storage_path: string;
  public_url: string | null;
  source_type: 'youtube' | 'supabase_storage' | 'cloudflare_r2' | 'local';
  file_name: string;
  description: string | null;
  size_bytes: number | null;
  duration_seconds: number | null;
  width: number | null;
  height: number | null;
  codec: string | null;
  bitrate: number | null;
  status: 'pending_upload' | 'uploaded' | 'processing' | 'ready' | 'error';
  processing_notes: Record<string, any> | null;
  uploaded_by: string;
  uploaded_at: string;
  created_at: string;
  updated_at: string;
  is_active: boolean;
}

export interface AssetMetadata {
  storagePath: string;
  publicUrl?: string | null;
  contentType?: string | null;
  sizeBytes?: number | null;
  width?: number | null;
  height?: number | null;
  timestampMs?: number | null;
  createdAt?: string | null;
}

export interface CaptureItem {
  id: string;
  name: string;
  type: CaptureItemType;
  size?: string;
  updatedAt?: string;
  owner?: string;
  status?: 'pending_upload' | 'uploaded' | 'processing' | 'ready' | 'error';
  children?: CaptureItem[];
  path?: string; // Storage path for folders
  videoId?: string; // Video ID for files
  storagePath?: string; // Full storage path for video files (for deletion)
  description?: string | null; // Description from DB for files
  video?: Video; // Full video object for files
  isAsset?: boolean; // Indicates derived asset (master / thumbnail / clip)
  assetKind?: 'master' | 'thumbnail' | 'clip' | 'folder';
  parentVideoId?: string;
  assetMetadata?: AssetMetadata;
}

export interface UploadFile {
  id: string;
  file: File;
  displayName?: string;
  description?: string;
  progress?: number;
  status?: 'pending' | 'uploading' | 'processing' | 'completed' | 'error';
  videoId?: string; // Store videoId to prevent duplicate DB rows on retry
  retryCount?: number;
  error?: string;
}

export interface ToastState {
  isVisible: boolean;
  type: 'success' | 'error' | 'info';
  message: string;
}

export const STATUS_STYLES: Record<NonNullable<CaptureItem['status']>, string> = {
  pending_upload: 'bg-gray-100 text-gray-800 border border-gray-200',
  uploaded: 'bg-blue-100 text-blue-800 border border-blue-200',
  ready: 'bg-green-100 text-green-800 border border-green-200',
  processing: 'bg-yellow-100 text-yellow-800 border border-yellow-200',
  error: 'bg-red-100 text-red-800 border border-red-200',
};

